import React, { Component } from 'react';
import { Divider, Switch, Button, Intent } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class DLLSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saved: false
    };
  }

  handleSave = (e) => {
    e.preventDefault();
    this.setState({ saved: true });
    setTimeout(() => this.setState({ saved: false }), 3000);
  };

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Client Security DLL & Anticheat Protection
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Configure client-side anticheat DLL hooks, memory scan hashes, and speed hack protection.
        </p>

        <Divider className="mb-4" />

        {this.state.saved && (
          <div className="alert alert-success py-2 mb-4" style={{ fontSize: '0.85rem' }}>
            Client Security DLL settings saved!
          </div>
        )}

        <div className="mb-4">
          <Switch label="Enable Memory Tamper & Injection Guard (v4.2.0)" defaultChecked />
          <Switch label="Block Multiclient Programs (Bot/Sandboxie detection)" defaultChecked />
          <Switch label="Block SpeedHack & Movement Teleport Hacks" defaultChecked />
          <Switch label="Enforce SROFilter Security DLL Checksum Signature" defaultChecked />
        </div>

        <Button intent={Intent.PRIMARY} icon="code" small onClick={this.handleSave} text="Update DLL Protection Config" />
      </SideMenuWrapper>
    );
  }
}
